import { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import FaqsItem from "../../components/Items/FaqsItem";
import AddFaqs from "../../components/Modals/AddFaqs";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { detailsFaqs, listCategories, listFaqs, ordering } from "../../helpers/api_helper";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Pagination from "../../components/Elements/Pagination";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { NoData } from "../../components/Elements/NoData";
const FaqList = () => {
  // Query Client instance
  const queryClient = useQueryClient();
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);

  // For Managing Modals
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [selectedCat, setSelectedCat] = useState([]);
  const [selectedCatOpt, setSelectedCatOpt] = useState([]);

  const [category_id, setCategory_id] = useState("");

  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState();

  const [isOne, setDataOne] = useState(false);
  const [dataList, setDataList] = useState([]);
  // To fetch Details of specific items when it needs to be edited
  const [editId, setEditId] = useState("");

  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);

  // Dynamic query key for Faqs 🗝️
  const queryFaqs = ["faqs", keyword, status, limit, offset, category_id];

  const addModal = () => {
    setIsAddModal(true);
  };

  const [perPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => detailsFaqs({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "") {
      refetch();
    }
  }, [editId, refetch]);

  function FaqList() {
    // Custom hook for fetching faq list
    function useFaq() {
      return useQuery({
        queryKey: queryFaqs,
        queryFn: () =>
          listFaqs({
            keyword: keyword,
            status: status,
            sortByField: "ordering",
            sortByValue: 1,
            category: category_id,
          }),
        keepPreviousData: true,
      });
    }

    const { data: faqs, error, isFetching } = useFaq();

    const handleDragEnd = (e) => {
      setDataOne(true);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);
      
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);

      onClickSaveOrdering(dataArray,tempData);
      setDataList(tempData);
      
    };
    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "faq",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryFaqs);
        queryClient.removeQueries({
          queryKey: ["faqs"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    useEffect(() => {
      //console.log(isOne);
      if (!isOne && faqs !== undefined) {
        setDataList(faqs?.data);
      }
    }, [isOne, faqs?.data]);

    // Handling loading state 😑
    if (isFetching) {
      return <Loading />;
    }

    // Handling error state 🥴
    if (error) {
      return <Error />;
    }

    // Check if their is no data 🤨
    else if (faqs.data.length === 0) {
      return <NoData />;
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId={"div"}>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {!isOne && dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <FaqsItem
                        key={item?._id}
                        index={index}
                        faqsId={item._id}
                        question={item?.question}
                        answer=<div
                          dangerouslySetInnerHTML={{ __html: item?.answer.substring(0,50)+ "..."}}
                        />
                        Cat_name={item?.category?.name}
                        descriptions={item?.description}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryFaqs}
                        status={item?.status}
                        setEditId={setEditId}
                        detailsFetch={refetch}
                        setEditModal={setIsEditModal}
                      />
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Pagination
            count={faqs.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  // console.log(status)
  
  function useCategory() {
    return useQuery({
      queryKey: ["faq_categories_dropdown"],
      queryFn: async () => {
        let tmp = [];
        const { data } = await listCategories(
            {
              limit: 9999,
              category_type: "faqs",
            }
        );
        
        data.forEach((item) => {
          tmp.push({ value: item.alias, label: item.name });
        });

        return tmp;
      },
    });
  }

  const { data: categories } = useCategory();

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters">
          <div className="input-items">
            {perPages && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={"Per Page"}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items">
            <Search
              state={keyword}
              setState={setKeyword}
              placeholder={"Search..."}
            />
          </div>
  
          <div className="input-items">
            {categories && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={categories}
                  value={selectedCatOpt || []}
                  placeholder={"Categories"}
                  onChange={(e) => {
                    setCategory_id(e.value);
                    setSelectedCatOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items items-end ms-auto gap-3">
            <Button
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryFaqs);
                queryClient.removeQueries({
                  queryKey: ["faqs"],
                  type: "inactive",
                });
                setOffset(0);
                setSelectedCat([]);
                setSelectedCatOpt([]);
                setKeyword("");
                setStatus("");
                setLimit(10);
                setSelectedPageOpt([]);
                setStatusStatic([]);
                setCategory_id("");
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Add FAQ"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>
      <div className="faqs-list">
        <FaqList
        />
      </div>

      
      {/* for Adding modal */}
      <Modal
        title={"Add FAQs"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(!isAddModal)}
      >
        <AddFaqs
          modalClose={() => setIsAddModal(false)}
          query={queryFaqs}
          isFetching={isFetching}
        />
      </Modal>
      {/* //For Edit Modal */}
      <Modal
        title={"Edit Faqs"}
        size={"md"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddFaqs
          modalClose={() => setIsEditModal(false)}
          query={queryFaqs}
          details={details}
          isFetching={isFetching}
        />
      </Modal>
    </>
  );
};

export default FaqList;
